import { deleteAnalysis } from "api/Finances";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useDeleteAnalysis = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteAnalysis, {
        onSuccess: () => {
            toast.success("Deleted sucesfully");
            queryClient.invalidateQueries('analysisCost');
        },
        onError: () => {
            toast.error("Something went wrong! Please try again later.");
        },
    })
}